'use client';

import { useIsPathname } from '../utils/hook/GNB';
import { useNavigateToBuyNow } from '../utils/hook/useNavigateToBuyNow';

import { CustomLink } from './CustomLink';

const NavbarStartButton = () => {
  const isManualPage = useIsPathname('/main');
  const { navigateToBuyNow } = useNavigateToBuyNow();

  if (isManualPage) {
    return (
      <div className="flex items-center gap-8px">
        <Button onClick={() => navigateToBuyNow()}>시작하기</Button>
      </div>
    );
  }

  return (
    <CustomLink href="/main">
      <Button>채소 구출하기</Button>
    </CustomLink>
  );
};

export default NavbarStartButton;

const Button = ({
  onClick,
  children,
}: {
  onClick?: () => void;
  children: React.ReactNode;
}) => {
  return (
    <button
      onClick={onClick}
      className="flex-center h-32px cursor-pointer rounded-sm bg-brand-1 px-8px transition-opacity"
      type="button"
    >
      <p className="text-16px font-semibold text-white">{children}</p>
    </button>
  );
};
